import { render, staticRenderFns } from "./IssueReports.vue?vue&type=template&id=fe85a2d2&scoped=true&"
import script from "./IssueReports.vue?vue&type=script&lang=js&"
export * from "./IssueReports.vue?vue&type=script&lang=js&"
import style0 from "./IssueReports.vue?vue&type=style&index=0&id=fe85a2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe85a2d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe85a2d2')) {
      api.createRecord('fe85a2d2', component.options)
    } else {
      api.reload('fe85a2d2', component.options)
    }
    module.hot.accept("./IssueReports.vue?vue&type=template&id=fe85a2d2&scoped=true&", function () {
      api.rerender('fe85a2d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/layout/IssueReports.vue"
export default component.exports